module.exports = __webpack_public_path__ + "images/banner-3.edc5deac940dcde3e5e32e54fde0b601.png";